// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-wrapper{position:relative;bottom:1px;left:3px;color:#586267}.question-wrapper :hover,.question-wrapper :focus{opacity:.7}`, "",{"version":3,"sources":["webpack://./src/components/QuestionHelper/index.scss"],"names":[],"mappings":"AAAA,kBACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,aAAA,CACA,kDAEE,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
